/**
 * Sanitize a git branch name into a DNS-safe slug.
 * Shared by src/utils/environment.js (browser) and vercel.mjs (Node, build time).
 * Must stay free of browser globals so it can be evaluated in Node.
 */
export const sanitizeBranchName = (branchName) => {
  return (
    branchName
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 30)
      // delete trailing hyphens
      .replace(/-+$/g, '')
  );
};
